import { moneyFormatter } from '../../../utils/currency';
import { TitulationPaymentInfo } from '../types';
import { ColumnTable, Button } from '@octano/global-ui';
import BadgeState from '../parts/BadgeState';

export function useTitulationPaymentColumns(texts: {
  title: string;
  paymentStatuses: {
    pending: string;
    paid: string;
  };
  table: {
    headers: {
      concept: string;
      amount: string;
      paymentDate: string;
      status: string;
      action: string;
    };
    values: {
      concept: string;
      button: string;
    };
  };
}): Array<ColumnTable<TitulationPaymentInfo>> {
  return [
    {
      columnName: 'concept',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      headerText: texts.table.headers.concept,
      width: '15%',
      cellFormat: () => <div>{texts.table.values.concept}</div>,
    },
    {
      columnName: 'amount',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      headerText: texts.table.headers.amount,
      cellFormat: ({ row }) => {
        return <div>{moneyFormatter().format(row.amount)}</div>;
      },
    },
    {
      columnName: 'paymentDate',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      headerText: texts.table.headers.paymentDate,
      cellFormat: ({ row }) => {
        return row.paymentDate && <div>{row.paymentDate}</div>;
      },
    },
    {
      columnName: 'status',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      headerText: texts.table.headers.status,
      cellFormat: ({ row }) => {
        if (row.status === 'paid') {
          return (
            <BadgeState status="approved" text={texts.paymentStatuses.paid} />
          );
        }
        return (
          <BadgeState status="pending" text={texts.paymentStatuses.pending} />
        );
      },
    },
    {
      columnName: 'action',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      headerText: texts.table.headers.action,
      width: '15%',
      cellFormat: ({ row }) => (
        <Button
          disabled //Desabilitado hasta que este implementado el proceso de pago
          size="sm"
          fullwidth
          text={texts.table.values.button}
          onClick={() => console.log(row)}
        />
      ),
    },
  ];
}
